/**
 * @deprecated ImageResponse moved from "next/server" to "next/og" since Next.js 14, please import from "next/og" instead.
 * Migration with codemods: https://nextjs.org/docs/app/building-your-application/upgrading/codemods#next-og-import
 */
export function ImageResponse(): never {
  throw new Error(
    'ImageResponse moved from "next/server" to "next/og" since Next.js 14, please import from "next/og" instead'
  )
}
